import { FlashSaleResponse } from '@/types/flash-sale'
import { FlashSaleFormatter } from '../formatter/__f.flash-sale'
import { httpClient } from './http-client'

export const __cFlashSaleService = {
  async getFlashSales() {
    try {
      const response = await httpClient.V3.get<FlashSaleResponse>(
        '/flash-sales/list-items'
      )
      console.log('response', response)
      return FlashSaleFormatter.reformatFlashSale(response)
    } catch (error) {
      console.log('error', error)
      return {
        current: null,
        next: null,
        countDownTime: null,
      }
    }
  },
}
